import { isHttpClientError } from 'core/infra/http/HttpClient'

import { isTokenExpiredError } from './isTokenExpiredError'

/**
 * True for 401s on invite endpoints that are not the dedicated "token expired"
 * response. Covers anonymous / missing / invalid credentials after enforcement.
 */
export function isUnauthorizedInviteError(error: unknown): boolean {
  if (!isHttpClientError(error)) {
    return false
  }

  if (error.response?.status !== 401) {
    return false
  }

  return !isTokenExpiredError(error)
}
